<template>
  <div
    id="conteudo-modal-historico-detalhes"
    class="modal-list-content"
    style="overflow: auto; padding: 8px 28px"
  >
    <div class="columns container-historico-timeline-detalhes is-flex-direction-row-reverse">
      <div class="column is-6 is-flex is-flex-direction-column container-detalhes-form">
        <div id="secao-detalhes">
          <h3 class="is-size-5 pl-2">Detalhes</h3>
          <p class="pl-5 mt-3">
            <strong>Empresa:</strong> {{ detalhesTarefa.empresa }}
          </p>
          <p class="pl-5 mt-1">
            <strong>Responsável:</strong>
            {{ detalhesTarefa.responsavel }}
          </p>
          <p class="pl-5 mt-1">
            <strong>Departamento:</strong>
            {{ detalhesTarefa.departamento }}
          </p>
          <p class="pl-5 mt-1 prazo-entrega">
            <strong>Prazo de entrega:</strong>
            {{ detalhesTarefa.prazoDeEntrega }}
          </p>
          <p class="pl-5 mt-1 prazo-entrega">
            <strong>Prazo de entrega legal:</strong>
            {{ detalhesTarefa.prazoLegal }}
          </p>
          <p v-if="detalhesTarefa.documentoId" class="pl-5 mt-1">
            <strong>Documento da baixa:</strong>
            <button
              v-if="documento.loading"
              class="button is-loading trf-is-borderless btn-documento-loading"
            />
            <span
              v-else
              :title="getDocumentoTitle()"
            >
              <a
                :class="{ 'ml-1': true, 'tag-a-disabled': !documento.existe }"
                v-e2e="'btn-visualizar'"
                aria-haspopup="true"
                target="_blank"
                :href="getUrlDocumento(detalhesTarefa)"
              >
                <span class="icon is-small">
                  <i class="mdi mdi-eye" aria-hidden="true"></i>
                </span>
                <span>Visualizar</span>
              </a>
            </span>
          </p>
        </div>

        <hr />

        <div id="secao-descricao" v-if="!isDescricaoVazia()">
          <h3 class="is-size-5 pl-2">Descrição da tarefa</h3>
          <div id="trf-detalhes-tarefa-descricao" class="pl-5 pr-5 mt-3 content" v-html="detalhesTarefa.descricao">
          </div>
        </div>
        <h3 v-else class="is-size-6 pl-2 has-text-grey">Não há descrição para esta {{ tarefa.isFase ? 'fase' : 'tarefa' }}.</h3>

        <div v-if="hasAnexos">
          <hr/>
          <TrfGestorAnexos
            :historico-id="historicoId"
            :fase-id="tarefa.faseId"
            :atendimento-id="tarefa.atendimentoId"
            :is-tarefa-concluida="isTarefaConcluida"
            :status-id="statusIdString"
            @anexos-alterados="handleAnexosAlterados"
          />
        </div>

        <hr />

        <div id="secao-comentario" ref="secaoComentario" data-cy="secao-comentario">
          <h3 v-if="!this.comentario.isEdicao" class="is-size-5 pl-2">Comentário:<span class="button is-loading is-white pl-2 pr-2 is-inline-block" style="height: 1.25em" v-if="isToolbarTextEditorLoading"></span></h3>
          <h3 v-else class="is-size-5 pl-2"> Edição de Comentário:<span class="button is-loading is-white pl-2 pr-2 is-inline-block" style="height: 1.25em" v-if="isToolbarTextEditorLoading"></span></h3>
          <div class="is-flex is-flex-direction-column is-align-items-flex-end">
            <TrfToolbarTextEditor
              :tipLabel="tipLabelComentario"
              :maxlength="comentario.maxLength"
              @changeText="doChangeComentario"
              @ready="($event) => ( isToolbarTextEditorLoading = $event)"
              ref="textEditor"
              data-cy="campo-comentario"
            />
            <div v-if="!this.comentario.isEdicao" class="is-flex is-flex-direction-row is-align-content-space-around is-align-items-center">
            <div v-if="this.tarefa.isTarefaDeAtendimento">
                <input
                type="checkbox"
                v-model="isChecked"
                data-cy="checkbox-nao-gerar-parecer"
                />
                <label class="checkbox"> Não gerar parecer no atendimento</label>
            </div>
            <TrfButton
              :disabled="isCampoComentarioVazio()"
              @click="adicionarComentario()"
              nome="Adicionar"
              :class="{'mt-3': true, 'is-loading': comentario.isSalvando}"
              classCor="is-primary"
              id="btn-adicionar-comentario"
              data-cy="btn-adicionar-comentario"
              :title="isCampoComentarioVazio()? `Preencha um comentário para habilitar a ação.` : ``"
            />
            </div>
            <div v-else class="is-flex is-flex-direction-row is-align-content-space-between is-align-items-center">
              <TrfButton
              :disabled="isCampoComentarioVazio()"
              @click="montarObjetoEdicaoComentario()"
              nome="Alterar"
              :class="{'mt-3': true, 'is-loading': comentario.isEditando}"
              classCor="is-primary"
              id="btn-adicionar-comentario"
              data-cy="btn-alterar-comentario"
              :title="isCampoComentarioVazio()? `Preencha um comentário para habilitar a ação.` : ``"
            />
            <TrfButton
              @click="editarTituloToolBoxEBotoes(),this.limparComentario()"
              nome="Cancelar"
              class="mt-3 ml-3"
              classCor="is-light"
              id="btn-cancelar-comentario"
              data-cy="btn-cancelar-edicao-comentario"
              :title="isCampoComentarioVazio()? `Preencha um comentário para habilitar a ação.` : ``"
            />
            </div>
          </div>
        </div>
      </div>

      <div
        class="
          is-flex is-justify-content-center is-align-items-center
          separador-colunas
        "
      >
        <span></span>
      </div>

      <div
        id="trf-historico-tarefa"
        class="column is-6 secao-historico-timeline py-0 my-3"
        :style="{ maxHeight: timelineMaxHeight }"
        @scroll="TrfMixAderirAoInfiniteScroll"
        data-cy="secao-historico"
      >
        <h3 class="is-size-5 pl-2">Histórico</h3>
        <div
          class="is-relative"
          :class="{ 'is-flex': !showTimeline }"
        >
          <TrfGlobalLoader
            type="overlay"
            v-if="showTimelineLoader"
            overlayColor="#FFF"
          />

          <div v-if="showTimeline">
            <TrfTimeline
              :historicosTarefa="historicosTarefa"
              :tarefa="this.detalhesTarefa"
              :objetoEdicaoTarefa="this.gerarObjetoParaArvore()"
              ref="timelineComponent"
              @carrega-historico="this._carregarHistoricoTimeline(true)"
              @edicao-comentario="this.edicaoComentario"
              @limpa-campos="this.limparComentario(),this.editarTituloToolBoxEBotoes()"
            />
            <div v-if="TrfMixInfiniteScroll.listagemCarregando && !TrfMixInfiniteScroll.paginacaoFinalizada">
              <span class="button is-large is-fullwidth is-loading trf-is-borderless mt-3"></span>
            </div>
          </div>

          <div v-else id="msg-tarefa-sem-timeline" class="m-auto">
            <p class="is-size-5 pl-2">Não há históricos para essa tarefa.</p>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
  
<script>
import TrfTimeline from "../Timeline";
import TrfGlobalLoader from "../GlobalLoader";
import TrfToolbarTextEditor from "../ToolbarTextEditor"
import TrfButton from "../Button";
import TrfGestorAnexos from "../GestorAnexos";
import { TrfMixinInfiniteScroll } from "../../mixins/infinitescroll";
import { timelineTarefasService } from "../../service/timeline-tarefas-service";
import { utils } from "../../util/utils";
import { tipoTarefaEnum } from "../../views/CadastroTarefas/enum/tipoTarefaEnum";
import { statusEnum } from "../../enums/statusEnum";
import { env } from "../../env";
import { documentoService } from "../../service/documento-service";
import { origemTarefaEnum } from "../../enums/origemTarefaEnum";

export default {
  name: "TrfDetalhesHistorico",
  components: {
    TrfTimeline,
    TrfGlobalLoader,
    TrfToolbarTextEditor,
    TrfButton,
    TrfGestorAnexos
  },
  mixins: [TrfMixinInfiniteScroll],
  props: {
    tarefa: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      showTimeline: true,
      showTimelineLoader: false,
      historicosTarefa: [],
      isToolbarTextEditorLoading: true,
      comentario: {
        html: "",
        plainText: "",
        maxLength: 5000,
        isSalvando: false,
        isEditando: false,
        isEdicao: false
      },
      isChecked: false,
      objetoEdicaoTarefa: [],
      showGlobalLoader: false,
      timelineMaxHeight: "100px",
      documento: {
        loading: true,
        existe: false
      }
    };
  },
  computed: {
    tipLabelComentario() {
      let count = this.comentario.maxLength;
      if(this.comentario.plainText) {
        count -= this.comentario.plainText.length;
      }
      const tipo = this.tarefa.isFase ? 'fase' : 'tarefa';
      return `Adicione informações complementares à ${tipo}, caso necessário - ${count} caracteres restantes.`;
    },
    detalhesTarefa() {
      if (!!!this.tarefa || this.tarefa == {}) {
        return {};
      }

      const detalhesTarefa = {
        tarefaId: this.tarefa.faseId ? this.tarefa.faseId : this.tarefa.id,
        nome: this.tarefa.nome,
        empresa: `${this.tarefa.empresa.externoId} - ${this.tarefa.empresa.nome}`,
        responsavel: this.tarefa.responsavel,
        departamento: this.tarefa.departamento,
        prazoDeEntrega: this.tarefa.data,
        prazoLegal: this.tarefa.prazoLegal,
        descricao: this.tarefa.isFase ? this.tarefa.descricao : this.tarefa.observacoes,
        fases: this.tarefa.fases,
        nomesAnexos: this.tarefa.nomesAnexos,
        documentoId: this.tarefa.documentoId
      };

      return detalhesTarefa;
    },
    filtrosRequisicaoCardHistoricoTimeline() {
      const objetoDeFiltro = {
        "historicoTarefa" : this.tarefa.faseId ? this.tarefa.historicoTarefaId : this.tarefa.id,
        "fase":this.tarefa.faseId ? this.tarefa.faseId : "",
        "sort[DESC]": "id",
        pagina: this.TrfMixInfiniteScroll.page || 1,
        limit: this.TrfMixInfiniteScroll.limit || 100
      };
      return objetoDeFiltro;
    },
    isTarefaConcluida() {
      return this.tarefa.statusId == statusEnum.CONCLUIDO;
    },
    isFaseDoLegalize() {
      return this.tarefa.isFase && this.tarefa.isTarefaDoLegalize;
    },
    hasAnexos() {
      const isTarefaAvulsaValida = this.isTarefaAvulsa && !origemTarefaEnum.DEPARTAMENTO_PESSOAL.equals(this.tarefa.origemTarefa);
      return isTarefaAvulsaValida || this.isFaseDoLegalize;
    },
    isTarefaAvulsa() {
      const tipoDeTarefaId = this.tarefa.tipoDeTarefaId;
      if(!tipoDeTarefaId) {
        return false;
      }
      
      return tipoDeTarefaId == tipoTarefaEnum.AVULSA || tipoDeTarefaId == tipoTarefaEnum.AVULSAENCADEADA;
    },
    historicoId() {
      return this.tarefa.isFase ? this.tarefa.historicoTarefaId : this.tarefa.id;
    },
    statusIdString() {
      return this.tarefa?.statusId?.toString() || null;
    }
  },
  methods: {
    doChangeComentario(value) {
      const plainText = this.$refs.textEditor.getValueAsText();
      if(plainText.length > this.comentario.maxLength) {
        return;
      }

      this.comentario.html = value;
      this.comentario.plainText = plainText;
    },
    limparComentario() {
      this.comentario.html = "";
      this.comentario.plainText = "";
      if(!this.$refs.textEditor) return;
      this.$refs.textEditor.limparCampo();
    },
    async adicionarComentario() {
      this.comentario.isSalvando = true;
      const registro = this.gerarObjetoParaArvore();
      const request = await timelineTarefasService.adicionarRegistro(registro);
      if(request.ok) {
        this._carregarHistoricoTimeline(true);
        this.limparComentario();
      }
      this.comentario.isSalvando = false;
    },
    gerarObjetoParaArvore() {
      const hoje = utils.formatarCampoDataParaEnvioAoBackendSemHora(new Date());
      const registroHistorico = {
        dataDaAcao: hoje,
        descricaoAcao: this.comentario.html,
        historicoTarefaId: this.tarefa.faseId ? this.tarefa.historicoTarefaId :this.tarefa.id,
        faseId: this.tarefa.faseId ? this.tarefa.faseId : null,
      }  
      if (!this.comentario.isEdicao) {
        registroHistorico.possuiParecerAtendimento = !this.isChecked,
        registroHistorico.acao = !this.isChecked ? "Comentário" : "Comentário interno"
      }

      return registroHistorico;
    },
    isCampoComentarioVazio() {
      const hasNotTarefa = !!!this.tarefa;
      const hasNotComentarioPreenchido = this.comentario.plainText.length <= 0;
      return hasNotTarefa || hasNotComentarioPreenchido;
    },
    isDescricaoVazia() {
      const hasNotTarefa = !!!this.tarefa;

      const plainText = this.HTMLStringToPlainText(this.detalhesTarefa.descricao);
      const hasNotDescricao = !!!this.detalhesTarefa.descricao || this.detalhesTarefa.descricao == "" && plainText.length <= 0;

      return hasNotTarefa || hasNotDescricao;
    },
    async TrfMixIncrementarPagina(page, limit) {
      this.TrfMixInfiniteScroll.page = page + 1;
      this.TrfMixInfiniteScroll.limit = limit;
      const request = await this._carregarHistoricoTimeline(false);
    },
    async _carregarHistoricoTimeline(resetar) {
      try {
        if (!!resetar) {
          this.resetarPaginacao();
        }
        const listaDeHistoricosTimeline = await timelineTarefasService.listar(
          this.filtrosRequisicaoCardHistoricoTimeline
        );
        await Promise.all(
          listaDeHistoricosTimeline.data.map(async (historico) => {
            historico.dataDaAcao = utils.formatarDataParaExibicaoNoDataTable(
              historico.dataDaAcao
            );
            historico.cor =
              this.atribuirCorAoCardDeAcordoComAcaoHistoricoTimeline(
                historico.acao
              );
            historico.foto = historico?.responsavel?.fotoId?
              historico?.responsavel?.fotoId :
              null
          })
        );
        this.historicosTarefa = [
          ...this.historicosTarefa,
          ...listaDeHistoricosTimeline.data,
        ];
        const total = parseInt(listaDeHistoricosTimeline.totalDeItens);
        this.TrfMixInfiniteScroll.paginacaoFinalizada =
          total == this.historicosTarefa.length;
        if(total == 0) {
          this.showTimeline = false;
        } else {
          this.showTimeline = true;
        }
      } catch (erro) {
        if (erro.name === "AbortError") {
          console.warn(
            "INFO: Carregamento da timeline cancelado pelo usuário."
          );
        } else {
          console.error(erro);
        }
      } finally {
        this.showTimelineLoader = false;
        const container = document.querySelector('#trf-historico-tarefa');
        if(!this.isScrollable(container)) {
          this.realizarPaginacao(container);
        }
      }
    },    
    resetarPaginacao() {
      this.showTimelineLoader = true;
      this.TrfMixInfiniteScroll.page = 1;
      this.TrfMixInfiniteScroll.limit = 3;
      this.TrfMixInfiniteScroll.paginacaoFinalizada = false;
      this.historicosTarefa = [];
    },
    atribuirCorAoCardDeAcordoComAcaoHistoricoTimeline(acao) {
      switch (acao) {
        case 'Anexo':
        case 'Comentário':
        case 'Comentário interno':
          return  "#6BC8B3"; 
        case 'Enviado':
          return "#587EAB";
        case 'Reabertura':
          return "#CDAD00"; 
        case 'Concluído':
          return "#66BB06";
        case 'Recorrência':
          return "#bcb7b7";
        case 'Edição': 
          return "#CDAD00";
        case 'Paralisado':
        case 'Paralisada':
          return "#666666";
        case 'Continuação':
          return "#cdad00";
      }
    },
    HTMLStringToPlainText(htmlString, trim = 0) {
      let tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlString;

      let plainText = tempDiv.textContent || tempDiv.innerText || "";

      if(trim > 0 && !isNaN(trim)) {
        plainText = plainText.substring(0,trim);
        plainText = plainText.trim();
      }

      return plainText;
    },
    async _carregarTarefa() {
      this.showTimelineLoader = true;
      await this._carregarHistoricoTimeline(true);
      this.setTimelineHeight();
    },
    _fecharTarefa() {
      const conteudoComScroll = document.getElementById("conteudo-modal-historico-detalhes");
      timelineTarefasService.abortarUltimoRequest('get');
      timelineTarefasService.abortarUltimoRequest('post');
      this.limparComentario();

      if(!!this.$refs.timelineComponent) {
        this.$refs.timelineComponent.closeAllCards();
      }
      if(!!conteudoComScroll) {
        setTimeout(() => {
          conteudoComScroll.scrollTo(0,0)
        }, 500);
      }
    },
    async edicaoComentario(data) {
      this.comentario.isEdicao = true;
      this.comentario.html = this.$refs.textEditor.iniciarTextEditorComValor(data.descricaoAcao);
      await this.$nextTick();
      this.comentario.plainText = this.$refs.textEditor.getValueAsText();
    },
    editarTituloToolBoxEBotoes() {
      this.comentario.isEdicao = false;
      this.comentario.isEditando = false;
    },
    montarObjetoEdicaoComentario() {
      this.comentario.isEditando = true;
      this.$refs.timelineComponent.alterarComentario();
    },

    async handleAnexosAlterados() {
      await this._carregarHistoricoTimeline(true);
      this.setTimelineHeight();
    },
    setTimelineHeight() {
      if (!this.$refs.secaoComentario) {
        this.timelineMaxHeight = 'calc(100vh - 200px)';
        return;
      }
      this.timelineMaxHeight = (this.$refs.secaoComentario.offsetHeight + this.$refs.secaoComentario.offsetTop - 77) + 'px';
    },
    getUrlDocumento(detalhes) {
      if(!this.documento.existe) return "";
      return `//${env.econtadorFront}Documentos/Visualizar/${detalhes.documentoId}`;
    },
    getDocumentoTitle() {
      return this.documento.existe
        ? "Clique aqui para visualizar o documento"
        : "Documento excluído"
    },
    async _carregarDocumento() {
      if(!this.detalhesTarefa.documentoId) return;
      this.documento.loading = true;
      this.documento.existe = await documentoService.hasDocumentoById(this.detalhesTarefa.documentoId);
      this.documento.loading = false;
    }
  },
  created() {
    this._carregarDocumento();
    this._carregarTarefa();
  }
};
</script>
  
<style lang="scss" scoped>
.modal-list-content {
  max-height: 100%;
  &::-webkit-scrollbar {
    width: 5px;
    height: 0px;
    @media screen and (max-width: 768px) {
      width: 2px;
    }
  }
  &::-webkit-scrollbar-track {
    background: #dbdbdb;
    border-radius: 9px;
    margin: 12px 0;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #969696;
    border-radius: 11px;
    border: 0px none #969696;
  }
  @media screen and (min-width: 1024px) {
    width: 1024px;
  }
  @media only screen and (min-width:100px) and (max-width:999px){
    height: 100%;
  }
}
.container-historico-timeline-detalhes{
  margin-bottom: 0;
  margin-top: 0;
}

.secao-historico-timeline {
  overflow-y: auto;
  padding-right: 0;
  margin-right: 12px;
  scrollbar-width: thin;
  scrollbar-color: #969696 #dbdbdb;
  @media screen and (max-width: 1023px) {
    max-height: none;
  }
}
 .secao-historico-timeline::-webkit-scrollbar , div#secao-descricao::-webkit-scrollbar {
  width: 5px;
  height: 0px;
  @media screen and (max-width: 768px) {
    width: 2px;
  }
}
 .secao-historico-timeline::-webkit-scrollbar-track , div#secao-descricao::-webkit-scrollbar-track {
  background: #dbdbdb;
  border-radius: 9px;
  margin: 12px 0;
}
 .secao-historico-timeline::-webkit-scrollbar-thumb , div#secao-descricao::-webkit-scrollbar-thumb {
  background-color: #969696;
  border-radius: 11px;
  border: 0px none #969696;
}
.trf-is-borderless {
  border:0 none!important;
  outline: 0 none!important;
}
div#secao-descricao {
  max-height: 200px;
  overflow: auto;
  flex-grow:1;
}
div#msg-tarefa-sem-timeline p {
  color:#31708f;
  text-align: center;
}
.separador-colunas span {
  border-left: 1px solid hsl(0deg, 0%, 86%);
  height: calc(100% - 30px);
  @media screen and (max-width: 768px) {
    border-bottom: 1px solid hsl(0deg, 0%, 86%);
    width: calc(100% - 10px);
  }
}
hr {
  background: hsl(0deg, 0%, 86%);
  height: 1px;
}
.prazo-entrega {
  display: inline-block;
  @media screen and (max-width: 768px) {
    display: block;
  }
}
.container-detalhes-form {
  max-height: 100%;
  flex-grow: 1;
  @media screen and (max-width: 768px) {
    max-height: none;
  }
}

label,input[type='checkbox'] {
  margin-top: 12px;
  margin-bottom: 0;
  font-weight: 100;
  margin-right: 8px
}

.tag-a-disabled {
  pointer-events: none;
  cursor: default;
  color: gray;
}

.btn-documento-loading {
  margin-top: -7px;
}

</style>